import VisaIcon from "~icons/brandico/visa"
import MastercardIcon from "~icons/brandico/mastercard"
import AmexIcon from "~icons/brandico/amex"
import MaestroIcon from "~icons/wpf/maestro"
import DinersClubIcon from "~icons/cib/cc-diners-club"
import CardIcon from "~icons/heroicons/credit-card-20-solid"
import IKOIcon from "~icons/heroicons/credit-card-20-solid"
import SavvyIcon from "~icons/heroicons/credit-card-20-solid"
import UnionPayIcon from "~icons/app/unionpay"
import JCBIcon from "~icons/fa-brands/cc-jcb"
import type { Component } from "vue"

const SUPPORTED_CARD_SCHEMES = [
  "visa",
  "mastercard",
  "amex",
  "americanexpress",
  "iko",
  "savvy",
  "unionpay",
  "dinersclub",
  "maestro",
  "jcb",
  "unknown",
] as const

const iconMap: Record<
  (typeof SUPPORTED_CARD_SCHEMES)[number],
  Component
> = {
  visa: VisaIcon,
  mastercard: MastercardIcon,
  amex: AmexIcon,
  americanexpress: AmexIcon,
  iko: IKOIcon,
  savvy: SavvyIcon,
  unionpay: UnionPayIcon,
  dinersclub: DinersClubIcon,
  maestro: MaestroIcon,
  jcb: JCBIcon,
  unknown: CardIcon,
}

export const getCardSchemeIcon = (
  cardScheme: string | null
): Component => {
  const normalizedCardScheme = (cardScheme ?? "unknown")
    .toLowerCase()
    .replace(" ", "")
    .replace("_", "")

  const closestSupportedScheme =
    SUPPORTED_CARD_SCHEMES.find((supportedScheme) =>
      supportedScheme.includes(normalizedCardScheme)
    ) ?? "unknown"

  return iconMap[closestSupportedScheme]
}
